import React from 'react';
import Codeblock from './Codeblock';
import { flexParentPropsObj } from '../constants/flexboxProps';


const FlexParentPanel = ({ dispatch, parentProps }) => {
  return ( 
    <div className="flex-parent-panel">
      <button className="btn bg-warning" onClick={() => dispatch({
        type: 'FLEX-PARENT-PROP-RESET'
      })}>Reset</button>

      {
        Object.keys(flexParentPropsObj).map((nameString, j) =>
         
        <Codeblock
            key={j}
            cssProp={flexParentPropsObj[nameString]}
            dispatch={dispatch}
            currentValueSelect={parentProps[nameString]}
          />)
      }
      

    </div>
   );
}
 
export default FlexParentPanel;